import * as React from "react";

import "./errors.scss";

import {cs}               from "@Common/react/chain-services";
import {keyed}            from "@Common/react/keyed";
import {scrollIntoView}   from "@Common/ui-components/light/scroll-into-view";
import {isParentNode}     from "@Common/utils/browser/is-child-node";
import {findDuplicateds2} from "@Common/utils/collections";
import {toGroups}         from "@Common/utils/collections";
import {equalDeep}        from "@Common/utils/objects";
import {isEmpty}          from "@Common/utils/objects";

import {findParent} from "../find-parent";

export const Errors = ({tags2, onHover, onOut}) => cs(

    ["duplicates", ({}, next) => next(findDuplicateds2(
        tags2,
        {
            compare: (t1,t2) => (
                equalDeep(t1.xdQa, t2.xdQa) &&
                findParent(t1.tag, (t) => isParentNode(t, t2.tag), {
                    reject: (t) => t.hasAttribute?.("xd-qa-type"),
                })
            ),
        }
    ))],
    ["invalidTypes", ({}, next) => next(toGroups(
        tags2.filter(({xdQa}) => !validTypes.includes(xdQa.type)),
        ({xdQa}) => xdQa.type,
    ))],
    ({duplicates, invalidTypes}, next) => (!!duplicates?.length || !isEmpty(invalidTypes)) && next(),
    ({duplicates, invalidTypes}) => (
        <div className="errors-6o3">
            {/*{console.log("invalidTypes", invalidTypes)}*/}
            {duplicates.map((dup, i) => cs(
                keyed(i),
                () => (
                    <div
                        className="item"
                        onMouseEnter={() => onHover(dup.by.xdQa)}
                        onMouseLeave={onOut}
                        onClick={async () => {
                            console.log(dup.dups.map(({tag}) => tag));
                            for (const {rect, tag} of dup.dups) {
                                if (rect.width !== 0) {
                                    scrollIntoView(tag);
                                    // await waitTimeout(100);
                                    // rerender.invoke();
                                    break;
                                }
                            }
                        }}
                    >
                        <div className="box">
                            {dup.dups.length}
                        </div>
                        <div className="xd">
                            <div className="type">
                                {dup.by.xdQa.type}
                            </div>

                            {dup.by.xdQa.name && (
                                <div className="name">
                                    - {dup.by.xdQa.name}
                                </div>
                            )}
                        </div>
                    </div>
                )
            ))}

            {Object.keys(invalidTypes).map((type) => cs(
                keyed(type),
                () => (
                    <div
                        className="item"
                        onMouseEnter={() => onHover({type})}
                        onMouseLeave={onOut}
                        onClick={async () => {
                            // {tag, xdQa}
                            const tags = invalidTypes[type];
                            console.log(tags.map(({tag}) => tag));
                            for (const {rect, tag} of tags) {
                                if (rect.width !== 0) {
                                    scrollIntoView(tag);
                                    // await waitTimeout(100);
                                    // rerender.invoke();
                                    break;
                                }
                            }
                        }}
                    >
                        <div className="box">
                            {type}
                        </div>
                    </div>
                )
            ))}
        </div>
    )
);

// Valid values for xd-qa-type
const validTypes = [
    "actual_text",
    "badge",
    "button",
    "card",
    "date_select", // "calendar",
    "checkbox",
    "dropdown",
    "dropdown_item",
    "dropdown_selected",
    "file_input",
    "icon",
    "image",
    "label",
    "link",
    "logo",
    "menu",
    "modal",
    "radio",
    "style_filter",
    "subcat",
    "tab",
    "template",
    "template_back",
    "text",
    "textarea",
    "textbox",
    "text_field",
    "tile",
    "tooltip",
    "iframe_id",
    "text_field_id",
];

